/**
 * Returns attributes to disable password managers and browser extensions
 * when browser extensions should be prevented from interfering.
 */
export function getDisableBrowserExtensionAttributes(disableBrowserExtensions: boolean) {
  if (disableBrowserExtensions) {
    return {
      'data-1p-ignore': '', // 1Password
      'data-lpignore': 'true', // LastPass
      'data-bwignore': 'true', // Bitwarden
      'data-form-type': 'other', // Dashlane
    } as const;
  }

  return {};
}

/**
 * Props interface for components that support browser extension control
 */
export interface BrowserExtensionControlProps {
  /**
   * Whether to disable password managers and browser extensions on this input.
   * When true (default), adds attributes to disable browser extension behavior.
   */
  disableBrowserExtensions?: boolean;
}
